<app-dialog-close-button class="close-button" [compact]="true" (closed)="close()"></app-dialog-close-button>
<h3 class="mat-text-primary font-wordCount-bold" style="margin: 0px; font-size: 20px">{{ title }}</h3>
<span style="font-size: 16px">Versions</span>
<hr class="version-history__rule" />
<p class="version-history__intro">
  Every time you make a modification, FlyMSG auto-saves and a version is created. The server stores a maximum of 999
  versions per FlyMSG. Versions beyond threshold are deleted.
</p>

<div class="versions-container">
  <!-- R8: version-history is a plain-array table (no matSort/mat-paginator ever
       existed here — 03-component-mapping.md row 29 confirms this one and
       "settings categories" are markup-only conversions) — plain <table class="vng-table">,
       no VngTableDataSource/vng-pagination needed. -->
  <div class="vng-table-responsive" *ngIf="!isLoading">
    <table class="vng-table" [ngClass]="isLoading ? 'blur-effect' : ''">
      <thead>
        <tr>
          <th style="color: #000; font-size: 14px">Modified</th>
          <th style="color: #000; font-size: 14px">Character Count</th>
          <th style="color: #000; font-size: 14px">Word Count</th>
          <th style="color: #000; font-size: 14px">Media Size</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of dataSource">
          <td class="version-history__cell" [ngClass]="!element.isAvailable ? 'grayed-out' : ''">
            {{ element.modified }}
            <div *ngIf="element.current" style="background-color: #f9ecff; width: 53px; height: 19px; display: inline">
              <span
                style="
                  color: #5f177f;
                  vertical-align: middle;
                  padding-left: 8px;
                  padding-right: 8px;
                  font-family: 'Open Sans';
                  font-size: 8px;
                "
              >
                CURRENT
              </span>
            </div>
          </td>

          <td class="version-history__cell" [ngClass]="!element.isAvailable ? 'grayed-out' : ''">
            {{ element.charCount }}
          </td>

          <td class="version-history__cell" [ngClass]="!element.isAvailable ? 'grayed-out' : ''">
            {{ element.wordCount }}
          </td>

          <td class="version-history__cell" [ngClass]="!element.isAvailable ? 'grayed-out' : ''">
            {{ element.mediaSize }}
          </td>

          <td class="col-actions version-history__cell" style="direction: rtl">
            <div *ngIf="!element.current" style="cursor: pointer">
              <img
                style="vertical-align: bottom; cursor: pointer"
                src="../../../assets/images/reset.png"
                alt=""
                (click)="openMakeCurrentDialog(element)"
                vngTooltip="Make Current"
                [ngClass]="!element.isAvailable ? 'grayed-out' : ''"
              />
              <img
                style="vertical-align: bottom; margin: 0 16px; cursor: pointer"
                src="../../../assets/images/trash.png"
                alt=""
                (click)="openDeleteVersionDialog(element)"
                vngTooltip="Remove Version"
                [ngClass]="!element.isAvailable ? 'grayed-out' : ''"
              />
              <img
                style="vertical-align: bottom; cursor: pointer"
                src="../../../assets/images/preview.png"
                alt=""
                (click)="openPreviewDialog(element)"
                vngTooltip="Preview"
                [ngClass]="!element.isAvailable ? 'grayed-out' : ''"
              />
            </div>
            <div *ngIf="element.current" style="cursor: default">
              <img style="vertical-align: bottom" src="../../../assets/images/reset.png" alt="" class="grayed-out hide" />
              <img
                style="vertical-align: bottom; margin: 0 16px"
                src="../../../assets/images/trash.png"
                alt=""
                vngTooltip="You can't remove a current version"
              />
              <img
                style="vertical-align: bottom"
                src="../../../assets/images/preview.png"
                alt=""
                vngTooltip="You can't preview a current version"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
